export interface ReleaseNoticeStatus {
  currentRelease: string;
  updateAvailable: boolean;
  message: string;
  publishedAt: string | null;
}

export interface AdminReleaseNoticeStatus {
  currentRelease: string;
  targetRelease: string | null;
  active: boolean;
  message: string;
  publishedAt: string | null;
}

export function currentClientRelease() {
  for (const script of Array.from(document.scripts)) {
    const match = script.src.match(
      /\/assets\/(index-[A-Za-z0-9_-]+\.js)(?:\?|$)/,
    );
    if (match?.[1]) return match[1];
  }
  return "development";
}
